import PosTree from './src/main';

/* istanbul ignore next */
PosTree.install = function(Vue) {
  Vue.component(PosTree.name, PosTree);
};

export default PosTree;
